import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import Login from "./components/pages/Login";
import CreateNew from "./components/pages/CreateNew";
import MyViews from "./components/pages/MyViews";
import Connections from "./components/pages/Connections";
import Home from "./components/pages/Home";
import StatDS from "./components/pages/StatDS";
import ViewPage from "./components/pages/ViewPage";
import Settings from "./components/auth/Settings";
import { AuthProvider } from "./components/auth/AuthProvider";
import ProtectedRoute from "./components/auth/ProtectedRoute";
import SignUp from "./components/auth/SignUp";
import Welcome from "./components/auth/Welcome";
import { TourProvider } from "@reactour/tour";
import { usePageTracking } from "./services/analytics";
import { initializeErrorReporting } from "./utils/errorReporting";
import ErrorBoundary from "./components/ErrorBoundary";

console.log("🔍 React App Loaded - Checking if ViewPage is active");
console.log("🔍 Current URL:", window.location.href);
console.log("🔍 Current Path:", window.location.pathname);

const steps = [
  {
    selector: ".textarea",
    content: "This is my first Step",
    position: "bottom",
  },
  {
    selector: ".submit",
    content: "This allows you to search for PUBLIC data, or search YOUR private.",
  },
  {
    selector: ".analyze",
    content: "Use ANALYZE to generate an trends, patterns, projections and gaps with data from this view.",
  },
  {
    selector: ".component-content",
    content: "Add context to your data with text elements.",
  },
  {
    selector: ".component-toolbar",
    content: "Add COMMENTS and TAGS .",
  },
  {
    selector: "#fm-toolbar",
    content:
      "Here you can add sources for data, format columns and rows, and set conditial formatting. On the right you can set a table or visualization.",
  },
];

const styles = {
  maskWrapper: (base) => ({ ...base }),
  popover: (base) => ({
    ...base,
    color: "#222",
    boxShadow: "0 0 3em rgba(0, 0, 0, 0.5)",
    backgroundColor: "#D9D9D9",
    fontSize: "0.9em",
    padding: "48px",
    margin: "16px",
  }),
  badge: (base) => ({ ...base, color: "#222" }),
};

function PageTrackingWrapper() {
  usePageTracking();
  return null;
}

function App() {
  // Initialize error reporting on app startup
  useEffect(() => {
    initializeErrorReporting();
  }, []);

  return (
    <ErrorBoundary>
      <TourProvider steps={steps} position={"left"} styles={styles}>
        <Router>
          <PageTrackingWrapper />
          <AuthProvider>
            <Routes>
              <Route path="/" element={<Login />} />
              <Route path="/signup" element={<SignUp isModal={false} />} />
              <Route element={<ProtectedRoute />}>
                <Route path="/welcome" element={<Welcome />} />
                <Route path="/home" element={<Home />} />
                <Route path="/statistics" element={<StatDS />} />
                <Route path="/views" element={<MyViews />} />
                <Route path="/views/:viewId" element={<ViewPage />} />
                <Route path="/connectors" element={<Connections />} />
                <Route path="/create-new" element={<CreateNew />} />
                <Route path="/settings" element={<Settings />} />
              </Route>
            </Routes>
          </AuthProvider>
        </Router>
      </TourProvider>
    </ErrorBoundary>
  );
}

export default App;
